import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn} from '@angular/forms';
import { Observable, timer } from 'rxjs';
import { map, switchMap, } from 'rxjs/operators';
import { TenantService } from '../../Services/tenant.service';
import { TenantAlreadyExistsError } from './exceptions/tenant-already-exists-error.model';

@Injectable({
    providedIn: 'root'
})
export class TenantValidator {
    constructor(private service: TenantService){}

    getValidator(): AsyncValidatorFn {
        const debounceTimeMs = 500;
        return (control: AbstractControl) => timer(debounceTimeMs).pipe(switchMap(() => this.checkTenantObservable(control.value)));
    }

    private checkTenantObservable(val: string): Observable<TenantAlreadyExistsError> {
        return this.service.checkTenantExists(val).pipe(
                map((doesExist) => doesExist ? new TenantAlreadyExistsError() : null)
        );
    }
}
